import { Logger } from 'vue-infra';
import { appCode, appName } from '../config';

const logger = Logger.getLogger('usersBackboneApp');

if (window._) {
  window._.noConflict();
}

const moduleInit = done => require.ensure(['./userManagement'], (require) => {
  require('./userManagement');
  require('../assets/scss/_userManagement.scss');
  done();
});

const getBackboneModuleDictionary = async function (locale, fallbackLocale) {
  const localDictionary = {};
  // load custom local
  try {
    localDictionary.localResource = await loadInContext(locale);
  } catch (e) {
    logger.error(`fail to load dictionary ${locale}`);
  }
  // load fallback local
  if (locale !== fallbackLocale) {
    try {
      localDictionary.fallbackLocaleResource = await loadInContext(fallbackLocale);
    } catch (e) {
      logger.error(`fail to load dictionary ${fallbackLocale}`);
    }
  }
  return localDictionary;
};


async function loadInContext(filename) {
  return new Promise((resolve) => {
    if (filename === 'en-US') {
      // en-US is excluded from bundle-loader and pre-loaded by default
      require([`./i18n/dictionaries/${filename}.js`], resolve);
    } else {
      // all other locals are loaded dynamically using the bundle-loader
      require(`./i18n/dictionaries/${filename}.js`)((dict) => {
        resolve(dict);
      });
    }
  });
}

const webpackPathInit = (leAppConfig) => {
  __webpack_public_path__ = leAppConfig.publicPath; // jshint ignore:line
  window.usersBackboneResourcePath = leAppConfig.publicPath ? leAppConfig.publicPath : '../../';
};

const config = {
  id: appName,
  keepDOMRendered: false,
  moduleName: appName,
  routePrefix: appCode,
  isBackboneModule: true,
  dictionaryName: 'LEUserManagement',
  personas: ['admin'],
};

// jquery upgrade from 1.9.1 to 3.7.0
// https://stackoverflow.com/questions/37738732/jquery-3-0-url-indexof-error
$.fn.load = $.fn.on;

// jquery upgrade from 1.9.1 to 3.7.0
// https://stackoverflow.com/questions/54411842/uncaught-typeerror-size-is-not-a-function
$(function () {
  $.fn.size = function () {
    return this.length;
  };
});

export default {
  config,
  moduleInit,
  getBackboneModuleDictionary,
  webpackPathInit,
};
